import { render, staticRenderFns } from "./MobAdForm.vue?vue&type=template&id=2cb034a8"
import script from "./MobAdForm.vue?vue&type=script&lang=js"
export * from "./MobAdForm.vue?vue&type=script&lang=js"
import style0 from "./MobAdForm.vue?vue&type=style&index=0&id=2cb034a8&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports